import { Grid, Typography } from "@mui/material";

import ProductCard from "@/components/Products/ProductCard";
import Section from "@/components/Section";
import { useGetProductsQuery } from "@/redux-store/api/marketingApi";

const OtherProducts = () => {
  const { data: products } = useGetProductsQuery({});

  return (
    <Section pt={0} pb={{ xs: 8.5, md: 10, lg: 17.5 }}>
      {products && (
        <>
          <Typography variant="h2" mb={{ xs: 2, md: 5 }}>
            Other devices
          </Typography>
          <Grid container spacing={{ xs: 3.5, sm: 3 }}>
            {products.map((product, index) => (
              <Grid item xs={12} sm={6} lg={3} key={index}>
                <ProductCard product={product} />
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </Section>
  );
};

export default OtherProducts;
